







import {Vue, Component} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import MemberFreeze from '@/views/member/MemberFreeze.vue';

@Component({
  components: {
    PageTitle,
    AdminIframe,
    MemberFreeze
  }
})
export default class DormantMemberIframe extends Vue {

  private get remoteSrc() {
    const src = process.env.VUE_APP_ADMIN_REMOTE_URL + '/member/basic/dormant?serviceType=PREMIUM';

    return src;
  }
}
